// src/cropYear/bookCropYear.js — THE book's crop year, one rule for browser and server.
//
// The crop year the book carries the most premium for. Premium, never row count:
// a forward year fills with empty coverage shells (policy numbers rolled forward,
// nothing rated) long before it carries the book, so counting rows flips too early.
// The calendar year is wrong both ways: on January 1 it names a year the book has
// barely started, and in the fall it can name a year whose book is already closing.
//
// Kevin, 2026-11-02: "Crop year rollover needs to happen everywhere". So Silas rolls
// when the book does, with no code change: the year with the most premium wins.
//
// CommonJS, no imports: App.jsx (adoptCropYearFromBook) and api/_book-crop-year.js
// both call it, and tools/check-book-crop-year.js drives it directly.

// policies: [{ id, crop_year }]; coverage: [{ policy_id, total_premium }].
// Returns the winning crop year as a Number, or null when nothing carries premium.
function pickBookCropYear(policies, coverage) {
  const yearOf = new Map();
  for (const p of policies || []) if (p && p.id != null) yearOf.set(p.id, p.crop_year);
  const byYear = new Map();
  for (const c of coverage || []) {
    const y = yearOf.get(c && c.policy_id);
    const v = Number(c && c.total_premium) || 0;
    if (y && v > 0) byYear.set(y, (byYear.get(y) || 0) + v);
  }
  let best = null, bestPrem = 0;
  for (const [y, v] of byYear) if (v > bestPrem) { best = y; bestPrem = v; }
  const n = Number(best);
  return best != null && Number.isInteger(n) && n >= 1990 && n <= 2100 ? n : null;
}

module.exports = { pickBookCropYear };
